module Internal.Debug where

import Data.Function.Uncurried (Fn2, runFn2)

foreign import debug_log :: forall a b. a -> b
foreign import debug_log_msg :: forall a b. Fn2 String a b

-- | Allows to use console.log without `Effect` for debugging.
debugLog :: forall a b. a -> b
debugLog val = debug_log val

-- | Allows to use console.log without `Effect` for debugging.
debugLog' :: forall a b. String -> a -> b
debugLog' msg val = runFn2 debug_log_msg msg val

-- | Like `debugLog` but also returns the value given.
debugTrace :: forall a. a -> a
debugTrace val = let x = debugLog val in val

-- | Like `debugLog` but also returns the value given.
debugTrace' :: forall a. String -> a -> a
debugTrace' msg val = let x = debugLog' msg val in val

